import { render, staticRenderFns } from "./transportOptionCreationBox.vue?vue&type=template&id=2873449e&"
import script from "./transportOptionCreationBox.vue?vue&type=script&lang=js&"
export * from "./transportOptionCreationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports